import { forwardRef, type InputHTMLAttributes } from 'react';

import { cx } from '../../utils/cx';

import styles from './text_input.module.css';

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  size?: 'm' | 'l';
  error?: boolean;
}

export const TextInput = forwardRef<HTMLInputElement, Props>(
  ({ className, size = 'm', error, ...props }, ref) => {
    return (
      <input
        ref={ref}
        className={cx([
          className,
          styles.text_input,
          styles[size],
          { [styles.error]: error, [styles.disabled]: props.disabled },
        ])}
        type="text"
        {...props}
      />
    );
  },
);
